/**
 * Mirrors backend/utils/placeImageSource.js so 60×40 CDN URLs match place_cdn_sync / seed.
 * `base` = stem with optional trailing `_place` removed once.
 */
export function placeBaseStemForPlaceSuffixFiles(stem: string): string {
  let s = stem.trim();
  if (!s) return s;
  if (s.endsWith('_place')) s = s.slice(0, -6);
  return s;
}

/** Final live tile: `60x40/{sub}/{base}_place.png` (same as place_cdn_sync). */
export function placeLivePlacePngUrl(cdnBase: string, subreddit: string, cdnStem: string): string {
  const base = placeBaseStemForPlaceSuffixFiles(cdnStem);
  const enc = encodeURIComponent(`${base}_place`);
  return `${cdnBase}/60x40/${subreddit}/${enc}.png`;
}

export function placeLivePlacePngUrlWithBust(
  cdnBase: string,
  subreddit: string,
  cdnStem: string,
  cacheBust?: string | null
): string {
  const u = placeLivePlacePngUrl(cdnBase, subreddit, cdnStem);
  const b = cacheBust != null && String(cacheBust).trim() !== '' ? String(cacheBust).trim() : '';
  if (!b) return u;
  return `${u}?v=${encodeURIComponent(b)}`;
}

export function placeSixtyFortyFlairUrls(cdnBase: string, subreddit: string, cdnStem: string): string[] {
  const base = placeBaseStemForPlaceSuffixFiles(cdnStem);
  const encStem = encodeURIComponent(cdnStem);
  const live = `${cdnBase}/60x40/${subreddit}/${encodeURIComponent(`${base}_place`)}.png`;
  const baseline = `${cdnBase}/60x40/${subreddit}/${encodeURIComponent(`${base}_place_0`)}.png`;
  const plain = `${cdnBase}/60x40/${subreddit}/${encodeURIComponent(base)}.png`;
  const liveIfSuffixed = cdnStem.endsWith('_place')
    ? [`${cdnBase}/60x40/${subreddit}/${encStem}.png`]
    : [];
  return [...new Set([...liveIfSuffixed, live, baseline, plain])];
}
